<template>
  <!-- 小码王风格菜单 -->
  <header>
    <div :class="['menu-bar']">
      <a-row type="flex" justify="space-between">
        <a-col :span="4">
          <div class="logo">
            <router-link to="/"><img src="/img/logo.png" alt="" /></router-link>
          </div>
        </a-col>
        <a-col :span="10" class="notify">
          <a-carousel :dots="false" :autoplay="true" effect="fade">
            <a @click="showNotify(t)" v-for="(t, i) in notifys" :key="i"
              ><a-icon type="notification" theme="filled" />{{
                t.titile | ellipsis(20)
              }}</a
            >
          </a-carousel>
          <a-modal v-model="showNotifyModal" :title="notify.titile" ok-text="确认" cancel-text="取消" @ok="showNotifyModal=false">
            <div v-html="notify.msgContent">
            </div>
          </a-modal>
        </a-col>
        <a-col :span="10">
          <a-menu mode="horizontal" class="user-menu">
            <a-sub-menu key="create">
              <span slot="title" class="submenu-title-wrapper">
                <router-link to="/teacher/center">
                  <a-avatar
                    style="backgroundcolor: #87d068"
                    icon="user"
                    :src="getQiniuUrl(userInfo.avatar) || '/img/avatar.png'"
                  />
                  {{ userInfo.realname }}
                  <a-icon type="down" />
                </router-link>
              </span>
              <a-menu-item key="center:student">
                <router-link to="/teacher/center">
                  <a-icon type="user" />个人中心
                </router-link>
              </a-menu-item>
              <a-menu-item key="4" @click="updatePassword">
                <a-icon type="setting" />
                <span>密码修改</span>
              </a-menu-item>
              <a-menu-item key="center:logout">
                <a @click="handleLogout" target="_blank"
                  ><a-icon type="poweroff" />退出登录</a
                >
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-col>
      </a-row>
    </div>
    <user-password ref="userPassword"></user-password>
  </header>
</template>
<script>
import Vue from "vue";
import { USER_ROLE } from "@/store/mutation-types";
import { mapActions } from "vuex";
import UserPassword from "@/components/common/UserPassword";
import { getAnnountCement } from "@/api/sys";
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "Menu",
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: { UserPassword },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      userInfo: {},
      showMenu: true,
      notifys: [],
      notify:{},
      showNotifyModal: false
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    if (Vue.ls.get(USER_ROLE) == "student") {
      window.document.location = `/student`;
    }
    console.log("用户信息：");
    console.log(this.userInfo);
    //需要登录的页面
    document.addEventListener("tokenInvaild", function (e) {
      // that.$router.push({
      //   path: `/user/login?role=teacher`,
      // });
      window.location.href = "/user/login?role=teacher";
    });
    getAnnountCement().then((res) => {
      this.notifys = res.result.records;
    });
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({ path: "/user/login" });
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    updatePassword() {
      let username = this.userInfo.username;
      this.$refs.userPassword.show(username);
    },
    showNotify(notify) {
      if (notify.href) {
        window.open(notify.href);
      } else {
        this.showNotifyModal = true
        this.notify = notify
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu-bar {
  width: 100%;
  padding: 9px 10%;
  background-color: var(--primary-color);
  transition: all 0.1s ease;
  // position: fixed;
  .logo {
    img {
      height: 50px;
    }
  }

  .notify {
    > div {
      display: inline-block;
      text-align: left;
      margin: 10px 5px;
      vertical-align: top;
    }
    .anticon {
      color: #fff;
      margin-right: 10px;
    }

    .ant-carousel {
      width: 90%;
      a {
        white-space: nowrap;
        color: #fff;
      }
    }
  }

  .menu {
    background: transparent;
    border-bottom: unset;
    .ant-menu-submenu,
    .ant-menu-item > a {
      font-size: 20px;
      font-weight: 700;
      color: white !important;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      // border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .user-menu {
    background: transparent;
    border-bottom: unset;
    font-size: 18px;
    text-align: center;
    span {
      a {
        color: white;
        font-size: 14px;
      }
      .ant-avatar {
        font-size: 20px;
      }
    }

    .help-center a {
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>